/** 
 * Entry point for the main chat interface. 
 * This re-exports the existing App component. 
 */
import { Routes, Route, Navigate } from 'react-router-dom'
import App from '../App.jsx'
import { useAutoUpdate } from '../hooks/useAutoUpdate.js'

/** 
 * ChatApp wraps the main App component and handles all routing
 */
const ChatApp = () => {
  useAutoUpdate()

  return (
    <Routes>
      <Route path="/settings" element={<App showSettings={true} />} />
      <Route path="/usage" element={<App showUsage={true} />} />
      <Route path="/chat" element={<App showSettings={false} />} />
      <Route path="/chat/:conversationId" element={<App showSettings={false} />} />
      <Route path="/" element={<Navigate to="/chat" replace />} />
      <Route path="*" element={<Navigate to="/chat" replace />} />
    </Routes>
  )
}

export default ChatApp
